import { PROP_TYPE } from "constants/enum";

export type InfoForGenerateFamilyInstance = {
  rootNode: any;
  mapDbId: Map<number, Autodesk.Viewing.PropertyResult>;
};

export enum CommonPropertyName {
  TYPE_NAME = "TypeName",
  FAMILY_NAME = "FamilyName",
}

export type MapCategory = {
  [key: string]: {
    [key: string]: {
      type: PROP_TYPE;
      displayName: string;
      displayCategory: string;
      value: Set<string | number>;
    };
  };
};

export enum ForgeDataType {
  FAMILY_INSTANCE_PROPERTY = "family-instance-property",
  FAMILY_INSTANCE_POSITION = "family-instance-position",
  SPACE = "space",
  CATEGORY_INFO = "category-info",
}

export const SUB_GENERATE_PATHS = {
  [ForgeDataType.FAMILY_INSTANCE_PROPERTY]: "family-instance-property",
  [ForgeDataType.FAMILY_INSTANCE_POSITION]: "family-instance-position",
  [ForgeDataType.SPACE]: "space",
  [ForgeDataType.CATEGORY_INFO]: "category-info",
};

export const PREFIX_COMMON = "c_";
export const PREFIX_OTHER = "o_";
export const DEFAULT_COMMON_GROUP_NAME = "";

export const GENERATED_DATA_FILE_NAME = "data.json.gz";

export enum TYPE_NODE {
  Root = 0,
  Category = 1,
  Family = 2,
  Type = 3,
  Instance = 4,
  NestedInstance = 5,
}

/*
  common level: Model => Category => Family => Type => Instance => Nested instance
 */
export const LEVEL_INSTANCE = 4;

export const IS_FORMAT_VALUE_WITH_UNIT_FOR_BIM_PROPERTIES = true;
export const IS_FORMAT_VALUE_FOR_BIM_PROPERTIES = true;

export enum GenerateDataType {
  FAMILY_INSTANCE_PROPERTY = 1,
  CATEGORY_INFO = 2,
  FAMILY_INSTANCE_POSITION = 3,
  SPACE = 4,
  FAMILY_INSTANCE_LEVEL = 5,
  SPACE_LEVEL = 6,
}

export const ROOT_GENERATED_DATA_PATH =
  typeof window !== "undefined" &&
  window?.location?.host?.startsWith("localhost")
    ? "local-test/generated-data"
    : "generated-data";

export interface CheckGeneratedData {
  urn: string;
  projectId: string;
  shouldCache?: boolean;
}

export interface DataGenerate {
  generatedFamilyInstanceProperty: boolean;
  generatedCategoryInfo: boolean;
  generatedFamilyInstancePosition: boolean;
  generatedSpace: boolean;
  // List guid of view that do not exist in the DB
  missingViews: string[];
}

export interface UpsertGeneratedData {
  urn: string;
  dataType: number;
}

export const EXCLUDE_MAP_CATEGORY_NAME_REGEX = [/^.*(FL|DWG)$/, /^<.*>$/];
